export default function combineComparators (...comparators) {
    return (a, b) => {
        return comparators.reduce((result, comparator) => {
            if (result !== 0) return result

            return comparator(a, b)
        }, 0)
    }
}
